import React from 'react';

const BillData = () => {
	const playStoreClick = () => {
		window.location.href =
			'https://play.google.com/store/apps/details?id=com.SadeepDhananjana.NWSDBSelfCare';
	};
	const appStoreClick = () => {
		window.location.href =
			'https://apps.apple.com/us/app/nwsdb-selfcare/id1577897602';
	};

	return (
		<div className='flex flex-1 justify-center items-center'>
			<div>
				<div className='p-4'>
					<div>
						<p className='text-blue-500 text-base'>NWSDB SelfCare App</p>
						<p className='text-gray-400 mt-1 text-sm'>
							Now you can manage all your water connections in one place.
						</p>
						<div className='flex justify-center items-center mt-4'>
							<div className='flex-1 pr-8'>
								<img
									src='appStore.png'
									alt='App Store'
									className='max-w-full h-auto cursor-pointer'
									onClick={appStoreClick}
								/>
							</div>
							<div className='flex-1 pl-8'>
								<img
									src='playStore.png'
									alt='Play Store'
									className='max-w-full h-auto cursor-pointer'
									onClick={playStoreClick}
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default BillData;
